import { ReceiptPreferences } from 'src/common/interfaces/dtos/IPreTenderAdd';
import { IReceiptArgs } from 'src/common/interfaces/dtos/IReceiptArgs';

export const getReceiptPreferences = ({
  printReceipt,
  emailAddress,
  mobilePhoneNumber,
  receiptDeliveryPreference,
}: IReceiptArgs): ReceiptPreferences => ({
  printReceipt,
  emailAddress,
  phoneNumber: mobilePhoneNumber,
  deliveryMethod: receiptDeliveryPreference,
});
